







import { defineComponent } from '@vue/composition-api'

// Components
import FacultadLista from '../components/FacultadLista.vue'
import EscuelaLista from '../components/EscuelaLista.vue'

export default defineComponent({
  components: {
    FacultadLista,
    EscuelaLista,
  },
  props: {
    universidadId: {
      type: Number,
      required: true,
    },
  },
})
